<template>
  <div v-if="!additionalQuote && showComponent" class="referenceLeasePortal">
    <horizontal-line v-if="!additionalQuote" class="horizontalLine" />
    <h5>{{ i18n.t('/ReferenceLeaseportal/BlockTitle') }}</h5>

    <div>
      <dl v-if="isEditing" class="referenceLeasePortal-details">
        <dt>{{ i18n.t('/ReferenceLeaseportal/OpdrachtnummerLease Label') }}</dt>
        <dd><input v-model="leaseReference.OpdrachtnummerLease" class="input" /></dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/Lessee Label') }}</dt>
        <dd><input v-model="leaseReference.Lessee" class="input" /></dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/Berijder Label') }}</dt>
        <dd><input v-model="leaseReference.Berijder" class="input" /></dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/ExtraInformatie Label') }}</dt>
        <dd>
          <textarea
            v-model="leaseReference.ExtraInformatie"
            style="border: 1px solid black"
            class="input"
          />
        </dd>

        <dt>
          <input v-model="leaseReference.ShowOnPdf" type="checkbox" />
          <span style="margin-left: 10px">
            {{ i18n.t('/ReferenceLeaseportal/ShowOnPdf Label') }}</span
          >
        </dt>
        <dd></dd>
      </dl>

      <div v-if="isEditing">
        <app-button
          button-type="submit"
          button-class="primary"
          data-qa="reference-leaseportal-save-button"
          @click="save"
        >
          {{ i18n.t('/ReferenceLeaseportal/ButtonSave') }}
        </app-button>
      </div>

      <dl v-if="!isEditing" class="referenceLeasePortal-details">
        <dt>{{ i18n.t('/ReferenceLeaseportal/OpdrachtnummerLease Label') }}</dt>
        <dd>
          <span class="lease-reference">{{ leaseReference.OpdrachtnummerLease }}</span>
        </dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/Lessee Label') }}</dt>
        <dd>
          <span class="lease-reference">{{ leaseReference.Lessee }}</span>
        </dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/Berijder Label') }}</dt>
        <dd>
          <span class="lease-reference">{{ leaseReference.Berijder }}</span>
        </dd>

        <dt>{{ i18n.t('/ReferenceLeaseportal/ExtraInformatie Label') }}</dt>
        <dd>
          <span class="lease-reference">{{ leaseReference.ExtraInformatie }}</span>
        </dd>

        <dt style="margin-top: 15px">
          <input
            :checked="leaseReference.ShowOnPdf"
            type="checkbox"
            :disabled="true"
            :readonly="true"
            style="margin-right: 10px"
          />
          <span style="margin-left: 10px">
            {{ i18n.t('/ReferenceLeaseportal/ShowOnPdf Label') }}</span
          >
        </dt>
        <dd>&nbsp;</dd>
      </dl>
    </div>

    <app-button
      v-if="!isEditing && isEditable"
      data-qa="change-lease-company-reference-button"
      button-class="action-primary"
      :disabled="!isEditable"
      @click="isEditing = !isEditing"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        aria-hidden="true"
      >
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
      </svg>
      <span>{{ i18n.t('/ReferenceLeaseportal/EditButton Label') }}</span>
    </app-button>
  </div>
</template>

<script>
import HorizontalLine from '@/components/generic/presentational/atoms/horizontalLine/HorizontalLine.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import { mapState } from 'vuex'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import StoreConnector from '@/helpers/StoreConnector'
import { EventBus } from '@/plugins/event-bus'
import leaseReferenceService from '@/helpers/leaseReferenceHelper'

export default {
  components: {
    AppButton,
    HorizontalLine,
  },
  mixins: [AdditionalOrder],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isEditing: false,
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      state(state) {
        return state[this.quoteNamespace]
      },
      quoteStatusIsSalesOrder(state, getters) {
        return getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
      customer(state, getters) {
        return getters[this.quoteNamespace + '/customer']
      },
      customerCompany(state, getters) {
        return getters[this.quoteNamespace + '/customerCompany']
      },
      hasLeaseCompany(state, getters) {
        return getters[this.quoteNamespace + '/hasLeaseCompany']
      },
      hasLeaseReference(state, getters) {
        return getters[this.quoteNamespace + '/hasLeaseReference']
      },
      leaseReference(state, getters) {
        return getters[this.quoteNamespace + '/leaseReference']
      },
      showComponent() {
        return this.hasLeaseCompany && this.leaseReference !== null
      },
    }),
    isEditable() {
      return !this.quoteStatusIsSalesOrder
    },
  },
  watch: {
    customer() {
      if (this.hasLeaseReference) {
        this.leaseReference.Berijder = leaseReferenceService.composeBerijder(this.customer)
      }
    },
    customerCompany() {
      if (this.hasLeaseReference) {
        this.leaseReference.Lessee = leaseReferenceService.composeLessee(this.customerCompany)
      }
    },
  },
  methods: {
    async save() {
      try {
        await StoreConnector.dispatch('quote/setLeaseReference', this.leaseReference)
        this.isEditing = false
      } catch (error) {
        const errorMessage = error?.response?.data?.Message || 'Er is een fout opgetreden.'
        EventBus.$emit('notification-warning', errorMessage)
      }
    },
  },
}
</script>

<style>
.lease-reference {
  white-space: pre-wrap;
}

.referenceLeasePortal-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
}

.remove-button {
  margin-left: 0.25em;
}
</style>
